import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError, PromiseHelper } from "../common/Exports";
import { AuthInfo } from "./IAuthentication";
var AuthHeader = "Ocp-Apim-Subscription-Key";
/**
 * @class
 */

export var CognitiveSubscriptionKeyAuthentication =
/**
 * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
 * @constructor
 * @param {string} subscriptionKey - The subscription key
 */
function CognitiveSubscriptionKeyAuthentication(subscriptionKey) {
  var _this = this;

  _classCallCheck(this, CognitiveSubscriptionKeyAuthentication);

  /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */
  this.fetch = function (authFetchEventId) {
    return PromiseHelper.fromResult(_this.privAuthInfo);
  };
  /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */


  this.fetchOnExpiry = function (authFetchEventId) {
    return PromiseHelper.fromResult(_this.privAuthInfo);
  };

  if (!subscriptionKey) {
    throw new ArgumentNullError("subscriptionKey");
  }

  this.privAuthInfo = new AuthInfo(AuthHeader, subscriptionKey);
};